import {FC, memo, useMemo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {useShallow} from 'zustand/react/shallow';
import {EllipseButton} from 'ui-kit';
import {useMessagesStore} from 'stores';

interface IProps {
  threadName?: string;
  lastVisibleIdx: number;
}

const ThreadPopupFC: FC<IProps> = ({threadName, lastVisibleIdx}) => {
  const {totalCount, actions} = useMessagesStore(useShallow((state) => state));

  const progress = useMemo(() => {
    if (totalCount > 0) {
      const leftAmount = totalCount - (lastVisibleIdx + 1);
      const leftPercent = (leftAmount * 100) / totalCount;
      return (100 - leftPercent) / 100;
    } else {
      return 100;
    }
  }, [totalCount, lastVisibleIdx]);

  return (
    <Box position={'absolute'} bottom={'calc(100% - 30px)'} right={'4px'} left={'4px'}>
      <Box
        h={'74px'}
        position={'relative'}
        transform={threadName ? 'scaleY(1)' : 'scaleY(0)'}
        transition={'transform var(--tr-150-ei)'}
        transformOrigin={'bottom center'}
      >
        {/* CONTAINER BG */}
        <Box
          h={'100%'}
          w={'100%'}
          position={'absolute'}
          bg={'{colors.textPrimarySuperLight}'}
          borderTopLeftRadius={'24px'}
          borderTopRightRadius={'24px'}
          zIndex={1}
        >
          {/* PROGRESS BAR BG */}
          <Box
            h={'100%'}
            bg={'white'}
            transition={'all var(--tr-500-ei-eo)'}
            transform={`scaleX(${progress})`}
            transformOrigin={'left center'}
            opacity={0.15}
          />
        </Box>

        <Box
          h={'100%'}
          position={'absolute'}
          left={0}
          right={0}
          zIndex={2}
          boxShadow={'{shadows.thread}'}
          borderTopLeftRadius={'24px'}
          borderTopRightRadius={'24px'}
        >
          <Flex justifyContent={'space-between'} alignItems={'center'} p={'10px 12px 40px 20px'}>
            <Box fontWeight={600} color={'white'}>
              {threadName}
            </Box>

            {threadName && (
              <EllipseButton
                isRounded
                icon={'Close'}
                size={'small'}
                iconSize={'s24'}
                variant={'dark'}
                onClick={actions.clearThread}
              />
            )}
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export const ThreadPopup = memo(ThreadPopupFC);
